module.exports = __webpack_public_path__ + "img/star.d30f409e.png";